webpackJsonp([114276838955818,60335399758886],{

/***/ 217:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(327);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(217);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _crp = __webpack_require__(640);
	
	var _crp2 = _interopRequireDefault(_crp);
	
	var _fom = __webpack_require__(644);
	
	var _fom2 = _interopRequireDefault(_fom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    "footer",
	    { className: "footer has-text-centered" },
	    _react2.default.createElement(
	      "div",
	      { className: "container", style: { maxWidth: '700px' } },
	      _react2.default.createElement(
	        "div",
	        { className: "columns" },
	        _react2.default.createElement(
	          "div",
	          { className: "column" },
	          _react2.default.createElement("img", { src: _crp2.default, style: { height: '80px' }, alt: "Cancer Research Program logo" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "column" },
	          _react2.default.createElement("img", { src: _fom2.default, alt: "McGill Faculty of Medecine logo" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "has-text-centered" },
	      "For donations, please contact Dr. Lebrun at ",
	      _react2.default.createElement(
	        "a",
	        { href: "mailto:jj.lebrun@mcgill.ca" },
	        "jj.lebrun@mcgill.ca"
	      ),
	      ". Thank you for your support."
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "has-text-centered" },
	      "Copyright \xA9 2018 Lebrun Lab. All rights reserved."
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(71);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(342);
	
	var _favicon32x = __webpack_require__(310);
	
	var _favicon32x2 = _interopRequireDefault(_favicon32x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navbar = function Navbar() {
	  return _react2.default.createElement(
	    "nav",
	    { className: "navbar is-fixed-top", role: "navigation", "aria-label": "main navigation" },
	    _react2.default.createElement(
	      "div",
	      { className: "navbar-brand" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/", className: "navbar-item" },
	        _react2.default.createElement("img", { style: { 'marginRight': '10px' }, src: _favicon32x2.default, alt: "Logo" }),
	        " Lebrun Lab"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "navbar-burger", "data-target": "navMenu" },
	        _react2.default.createElement("span", null),
	        _react2.default.createElement("span", null),
	        _react2.default.createElement("span", null)
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "navbar-menu", id: "navMenu" },
	      _react2.default.createElement(
	        "div",
	        { className: "navbar-end" },
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-item" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement("i", { className: "fas fa-home navbar-icon" }),
	            "Home"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-item has-dropdown is-hoverable" },
	          _react2.default.createElement(
	            "span",
	            { className: "navbar-link" },
	            _react2.default.createElement("i", { className: "fas fa-flask navbar-icon" }),
	            "Lab"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "navbar-dropdown" },
	            _react2.default.createElement(
	              "div",
	              { className: "navbar-item" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/about" },
	                "About"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "navbar-item" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/principal-investigator" },
	                "Principal Investigator"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "navbar-item" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/team" },
	                "Lab members"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "navbar-item" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/alumni" },
	                "Alumni"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-item has-dropdown is-hoverable" },
	          _react2.default.createElement(
	            "span",
	            { className: "navbar-link" },
	            _react2.default.createElement("i", { className: "fas fa-microscope navbar-icon" }),
	            "Research"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "navbar-dropdown" },
	            _react2.default.createElement(
	              "div",
	              { className: "navbar-item" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/research" },
	                "Projects"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "navbar-item" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/publications" },
	                "Publications"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "navbar-item" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/protocol" },
	                "Protocol"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-item" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/news" },
	            _react2.default.createElement("i", { className: "fas fa-newspaper navbar-icon" }),
	            "News"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-item" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/contact" },
	            _react2.default.createElement("i", { className: "fas fa-globe navbar-icon" }),
	            "Contact"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-item" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/donate" },
	            _react2.default.createElement("i", { className: "fas fa-dollar-sign navbar-icon" }),
	            "Donate"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "navbar-item" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/links" },
	            _react2.default.createElement("i", { className: "fas fa-external-link-alt navbar-icon" }),
	            "Links"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Navbar;
	module.exports = exports["default"];

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crp.383de2ab.png";

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon-256x256.04e7dc39.png";

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAGLElEQVRYR7VXbWwU1xU9b3b2a3btXS9eYzsYDA7BaQjrQGlDqLyGpJWqEDCUoFJVdaxIbZXQOKSpXLU/EvoVoqoBJyRSm1YJVFBoKwhKU4k2AiOh/Glg2aqqowYTUzVpQiF4/bEz875uNYPt0Ajvbo0zf/bHzN5z7rnn3ncfww0+NIgELuNJFNEJF82wMQSOlwD0sS0olAvPyn1Q6r34QXS1cY9z0AjQPLgAbGDq18EwbHSwbyJfKsaMCVBvTcIdZQ8UinpNkfQdZqPblLqNf2BVUf01ZM6C0MG+Mb0SMybw8az+tj7WNWLrHbVLeXrxncrySTi+Kn2sB49Op8K0BOjrlFB6ZIOSWAOp20hSGyRBCT3MFM6S0CcMEdobPV5zYTL4m/cgcdkJnUwvljff0aFjPokihtijWFgxAeqlhC6O9ZCk7VpS0gMlQYAiUJzBuCUA1mqCgUErDRgsFzyH+9hj1rseyJ9XIDGK4MnV3bek625d1oiL/wAunE6y716/DP+jAPXyjHT4PggsHhlgfPifgWrbBYY/NMAsjVjGQGqlRjoLGWowgiCANAEuCZzhm8xt1X/wSBxeaWZVKHJi84GDzCOOhevqGWMfXE+FKQI++Jh4beSNQPLKgPF7AZywJRuSE6V0YMKGXCOY0ekQZeavVrSsW1O81TB8dQRxleObItsTr3lA+5YG+jf/7KGWaP2SOpbZFi5ZAmqnJj7H/u3oqUC/8Z/QzhRYyf49YFLW1rrPZcise8JBQ7sBKACcOJ3hq0LfT57Zeyt6Pv94Z3fDzc2nWHb3tmsJXAq9tUFKNNfr1j5fAb7I2aXeC++OOmzKUJXMhxcM9TJnrGvLj2yk25hfDn1JvRPpql6073Zkmz/b8qX2Xw4+4sW6kjy/QEE+SRKdxIkRR3YuluQZgRKsTMalyDzDZH+wirU/+HObmRHmm1W9zX/86oupn245j8LYdy62ub8e9Uz9gGdozXXeLJrZFFp8lW94DuwBLRhjNPSFrzq09F7NfBVG9L8jg4HlTi0/xOoC7cUdl0HjBC1UPjAcmAKfFQJekKcM9XLQwte+9XzRdz2R7wcHBiKkCPzYOMQpe6+hWU/qytXMJ58bVsALtBOUcRnOPtg7gtpmXDUkETxwr1XVRXki/pP02pJtWInpSn2zA3p4S/d49cKMYr4CHrgG1Hvymfju9LcrnoQzIeIp0Nk99pfm21TQH0wTCqj35ffiz9Y99YmchpNBDzbJDW0d9u8WfEoGvYz90e0przRiP6wtW+KyH5Rif6ieP7x2q/NcPKWYV2sfXBNIAl4drKc/QQKH0/zh9q32s7EabWAC1E9dTCjAVTG+Z26sXElnpMCROe7Tn9vqPB5PasOrtye3GiEx9K4pFjULizwPuDoX/9Xc5bNO4NVq/pu7vmLfbyV1YBKcCXp7z4s17qYvFurra2UtaYBsebTqQGPnrBL4U4IfWNFZ3GyZKggBkNBe6QeOn05s/fsFM/fQly85jFHU80CgSI9Yh+ufmzUCx2Pu/mWrxzdaURX1MxcaEMhbhWB2Zy6x/dONY713zh+LUIT5AygciS+OHEucmxUCb8Tc/a0dxY3RqI5e3ZC05/S8pczs86/XJEVAn+1a/n7EVBQh78ARdLRmYH5Z+Ss6C96M8/0ta4sbo9ZVcO2BK8pbjpllr6cK3mm4/vYPV9RFRHxyfTMEOqreajpZLvuyBHJB3tVyn/2LsKVD3mjVXotJnY+OBXzwl0Jy/6rWwr03xd3ExFYEktSX+GvTtFvwx0lN24YDpsjWrOLHalpEeDI4JBWoaGQO/zGJVJ195DNLRltCTFdPvReUrypYWXY+VfZGVPI0HAQlzEXOQMPdvGFqK5ZU+Nc74cfscb0uPcddWRXV87xyQE50g9QFQyAbz80reROqSIHBMO+Zc7fYFbtJMk92P0NOBShK+KCTXSDhewLK23LYhmiu8f9a6ab1wLkI72/udrNaehl+dC/wyUx0gUfCN6SgHfHx8C52unLZyy4k58LuK4338/XBqP5IgQlwH1SiAKFfMWToiWtvRpW4vqISnA/yDOr0ofRdfH44rqOa0wVoGiJB/YaiXPhI7dGZgF3vP/8FlYhLTmsZw2QAAAAASUVORK5CYII="

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon-512x512.2efbbb6b.png";

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fom.81023670.png";

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Navbar = __webpack_require__(326);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Footer = __webpack_require__(324);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(553);
	
	var _favicon32x = __webpack_require__(310);
	
	var _favicon32x2 = _interopRequireDefault(_favicon32x);
	
	var _favicon256x = __webpack_require__(641);
	
	var _favicon256x2 = _interopRequireDefault(_favicon256x);
	
	var _favicon512x = __webpack_require__(642);
	
	var _favicon512x2 = _interopRequireDefault(_favicon512x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Lebrun Lab"
	      ),
	      _react2.default.createElement("script", {
	        defer: true,
	        src: "https://use.fontawesome.com/releases/v5.2.0/js/all.js"
	      }),
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _favicon32x2.default, sizes: "32x32" }),
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _favicon256x2.default, sizes: "256x256" }),
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _favicon512x2.default, sizes: "512x512" })
	    ),
	    _react2.default.createElement(_Navbar2.default, null),
	    _react2.default.createElement(
	      "div",
	      { style: { marginBottom: "10rem" } },
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

	"use strict";
	
	//docs: read https://bulma.io/documentation/components/navbar/
	
	if (typeof document !== "undefined") {
	  document.addEventListener("DOMContentLoaded", function () {
	    // Get all "navbar-burger" elements
	    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".navbar-burger"), 0);
	
	    // Check if there are any navbar burgers
	    if ($navbarBurgers.length > 0) {
	      // Add a click event on each of them
	      $navbarBurgers.forEach(function ($el) {
	        $el.addEventListener("click", function () {
	          // Get the target from the "data-target" attribute
	          var target = $el.dataset.target;
	          var $target = document.getElementById(target);
	
	          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
	          $el.classList.toggle("is-active");
	          $target.classList.toggle("is-active");
	        });
	      });
	    }
	  });
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-8ee50ba4623230b9a6ad.js